/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InovalonPayer } from './InovalonPayer';
import {
    InovalonPayerFromJSON,
    InovalonPayerFromJSONTyped,
    InovalonPayerToJSON,
    InovalonPayerToJSONTyped,
} from './InovalonPayer';

/**
 * 
 * @export
 * @interface GetInovalonPayerList200Response
 */
export interface GetInovalonPayerList200Response {
    /**
     * 
     */
    data?: Array<InovalonPayer>;
}

/**
 * Check if a given object implements the GetInovalonPayerList200Response interface.
 */
export function instanceOfGetInovalonPayerList200Response(value: object): value is GetInovalonPayerList200Response {
    return true;
}

export function GetInovalonPayerList200ResponseFromJSON(json: any): GetInovalonPayerList200Response {
    return GetInovalonPayerList200ResponseFromJSONTyped(json, false);
}

export function GetInovalonPayerList200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInovalonPayerList200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(InovalonPayerFromJSON)),
    };
}

export function GetInovalonPayerList200ResponseToJSON(json: any): GetInovalonPayerList200Response {
    return GetInovalonPayerList200ResponseToJSONTyped(json, false);
}

export function GetInovalonPayerList200ResponseToJSONTyped(value?: GetInovalonPayerList200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(InovalonPayerToJSON)),
    };
}

